import UltMeta, { Meta } from "./UltMeta/index";

class DragType extends UltMeta {
    INSIDE = new Meta(1, "在里面");
    FRONT = new Meta(2, "在前面");
    BEHIND = new Meta(3, "在后面");
}
export const DRAG_TYPE = new DragType();
